import { stringify } from "query-string";
import { getData } from "../../../Context/backend";


export const getProductosServicios = async query => {    
    let data = [];
    let queryParamsObj = {
        "query": query
    }
    const url = `sat/ConsultarProdServicio?${stringify(queryParamsObj)}`
    const res = await getData(url);
    return new Promise((resolve, reject) => {
        if (!res.error) {
            data = res.data.respuesta;
            resolve(data);
        } else {
            reject(res);
        }
    });
}

export const getInfoProductoServicio = async clave => {
    let data = [];
    let queryParamsObj = {
        clave: clave,
    };
    const url = `sat/getInfoProductoServicio?${stringify(queryParamsObj)}`;
    const res = await getData(url);
    return new Promise((resolve, reject) => {
        if (!res.error) {
            data = res.data.respuesta;
            resolve(data);
        } else {
            reject(res);
        }
    });
}

export const getUnidadesMedidas = async query => {
    let data = [];
    let queryParamsObj = {
        "query": query
    }
    const url = `sat/ConsultarUnidadMedida?${stringify(queryParamsObj)}`
    const res = await getData(url);
    return new Promise((resolve, reject) => {
        if (!res.error) {
            data = res.data.respuesta;
            resolve(data);
        } else {
            reject(res);
        }
    });
}

export const getInfoUnidadMedida = async clave => {
    let data = [];
    let queryParamsObj = {
        clave: clave,
    };
    const url = `sat/getInfoUnidadMedida?${stringify(queryParamsObj)}`;
    const res = await getData(url);
    return new Promise((resolve, reject) => {
        if (!res.error) {
            data = res.data.respuesta;
            resolve(data);
        } else {
            reject(res);
        }
    });
}

export const getUnidadesMedidasInternas = async (query) => {
    let data = [];
    let queryParamsObj = {
      query: query,
    };
    const url = `sat/ConsultarUnidadMedidaInterna?${stringify(queryParamsObj)}`;
    const res = await getData(url);
    return new Promise((resolve, reject) => {
      if (!res.error) {
        data = res.data.respuesta;
        resolve(data);
      } else {
        reject(res);
      }
    });
  };